import ReactScatterGraph from './scatter-graph';
export default ReactScatterGraph;
